import api from "./API";

const conferir = (resposta, mensagemPadrao) => {
  if (resposta?.data?.status === false) {
    throw new Error(resposta?.data?.message || mensagemPadrao);
  }
  return resposta?.data;
};

/** Cronometro aberto do usuario (ou null) + quanto ele ja apontou hoje/semana. */
export async function buscarEmAndamento() {
  const resposta = await api.get("/time-entries/em-andamento");
  const dados = conferir(resposta, "Nao foi possivel consultar o cronometro.");
  return { record: dados?.record || null, resumo: dados?.resumo || null };
}

/**
 * Inicia o cronometro. Devolve tambem o segmento que foi encerrado quando a
 * pessoa estava contando tempo em outra tarefa - a tela precisa dizer isso.
 */
export async function iniciarCronometro(taskId) {
  const resposta = await api.post(`/tasks/${taskId}/time-entries/start`);
  const dados = conferir(resposta, "Nao foi possivel iniciar o cronometro.");
  return { record: dados?.record || null, encerrada: dados?.encerrada || null };
}

export async function pararCronometro(taskId) {
  const resposta = await api.post(`/tasks/${taskId}/time-entries/stop`);
  const dados = conferir(resposta, "Nao foi possivel parar o cronometro.");
  return dados?.record || null;
}

export async function listarApontamentos(taskId) {
  const resposta = await api.get(`/tasks/${taskId}/time-entries`);
  const dados = conferir(resposta, "Nao foi possivel carregar os apontamentos.");
  return { registros: dados?.records || [], totais: dados?.totais || null };
}

export async function lancarApontamento(taskId, payload) {
  const resposta = await api.post(`/tasks/${taskId}/time-entries`, payload);
  return conferir(resposta, "Nao foi possivel lancar o tempo.")?.record;
}

export async function corrigirApontamento(id, payload) {
  const resposta = await api.put(`/time-entries/${id}`, payload);
  return conferir(resposta, "Nao foi possivel corrigir o apontamento.")?.record;
}

export async function removerApontamento(id) {
  const resposta = await api.delete(`/time-entries/${id}`);
  conferir(resposta, "Nao foi possivel remover o apontamento.");
}
